module.exports = __webpack_public_path__ + "static/media/FASNYLogoProcess3.b75fcab2.jpg";